export default __webpack_public_path__ + "static/media/screenshot1.eca0fbee.png";